export default __webpack_public_path__ + "static/doktor-kladivo-web-51ec5c0909dac2f2c22a2c98d7446f4a.jpg";